import { IconButton, Stack, TextField } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

export interface ChatComposerProps {
  value: string;
  onChange: (v: string) => void;
  onSend: () => void;
  disabled: boolean;
  maxChars: number;
}

export function ChatComposer({ value, onChange, onSend, disabled, maxChars }: ChatComposerProps) {
  const length = value.trim().length;
  const tooLong = length > maxChars;
  const canSend = !disabled && length > 0 && !tooLong;
  return (
    <Stack direction="row" gap={1} alignItems="flex-start" sx={{ p: 1.5, borderTop: '1px solid', borderColor: 'divider' }}>
      <TextField
        label="Your question"
        size="small"
        fullWidth
        multiline
        maxRows={4}
        value={value}
        error={tooLong}
        helperText={`${length.toLocaleString('en-US')} / ${maxChars.toLocaleString('en-US')}${tooLong ? ' · shorten your question to send it' : ''}`}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            if (canSend) onSend();
          }
        }}
        slotProps={{ formHelperText: { sx: { textAlign: 'right', mx: 0 } } }}
      />
      <IconButton color="primary" aria-label="Send question" disabled={!canSend} onClick={onSend} sx={{ mt: 0.25 }}>
        <SendIcon />
      </IconButton>
    </Stack>
  );
}
